import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "h-60 rounded-100 position-relative",
  style: {"width":"100%","background-color":"rgba(var(--color-black-rgb), 0.1)"}
}
const _hoisted_2 = { class: "widget-floating py-0 text-xl flex-right" }
const _hoisted_3 = { class: "font-medium" }
const _hoisted_4 = { class: "s10" }
const _hoisted_5 = { class: "secondary-font font-semibold mb-1" }
const _hoisted_6 = { class: "secondary-font font-semibold text-grey-900 py-1" }
const _hoisted_7 = { class: "s10 text-right" }
const _hoisted_8 = {
  key: 0,
  class: "secondary-font font-semibold text-grey-600 pb-2"
}
const _hoisted_9 = {
  key: 1,
  class: "mb-4"
}
const _hoisted_10 = {
  key: 2,
  class: "secondary-font font-semibold text-grey-600 pt-1 mb-4"
}

import { onMounted, ref } from 'vue';
import { useToastStore } from '@/stores/toast.store';
import { formatAmount, formatDateFrench } from '@/utils';
import axios from 'axios';
import CustomWidget from '@/components/CustomWidget.vue';

interface PrelevementMensuel {
    id: number;
    souscription_id: number;
    mois: number;
    date_prevision: string | null;
    date_operation: string | null;
    montant: number;
    statut: 'pending' | 'done' | 'cancelled';
    countdown: string | null;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'UserPrelevementsMensuels',
  props: {
    userId: {}
  },
  setup(__props: any) {

// @ts-expect-error raison: lib externe mal typée
const props = __props;
const toastStore = useToastStore();
const loading = ref(false);
const stats = ref<{
    total_attendu: number,
    total_effectue: number,
    percent: number
}>({
    total_attendu: 0,
    total_effectue: 0,
    percent: 0
});
const prelevements = ref([] as any[]);
const minimized = ref(true);

onMounted(() => {
    loadPrelevementsMensuels();
});

async function loadPrelevementsMensuels() {
    try {
        loading.value = true;
        const httpResponse = await axios.get(`/backoffice/users/${props.userId}/prelevements_mensuels`);
        prelevements.value = httpResponse.data.items;
        stats.value = httpResponse.data.stats;
    } catch(e: any) {
        toastStore.error(e.message ?? "Une erreur est survenue lors de la requête au serveur");
    } finally {
        loading.value = false;
    }
}

async function validatePrelevementMensuel(detail: PrelevementMensuel) {
    loading.value = true;
    try {
        await axios.post(`/backoffice/users/${props.userId}/prelevements_mensuels/${detail.id}/validate`);
        await loadPrelevementsMensuels();
    } catch (e: any) {
        toastStore.error(e.message ?? "Une erreur est survenue lors de la requête au serveur");
    } finally {
        loading.value = false;
    }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CustomWidget, {
    title: "Prélèvement mensuel",
    items: prelevements.value,
    loading: loading.value
  }, {
    action: _withCtx(() => [...(_cache[0] || (_cache[0] = [
      _createElementVNode("button", { class: "btn lg py-3 black active" }, [
        _createElementVNode("img", {
          src: "/icons/icon-pdf.svg",
          class: "btn-icon",
          alt: ""
        }),
        _createElementVNode("span", null, "Exporter en PDF")
      ], -1),
      _createElementVNode("button", { class: "btn lg py-3 black active" }, [
        _createElementVNode("img", {
          src: "/icons/icon-excel.svg",
          class: "btn-icon",
          alt: ""
        }),
        _createElementVNode("span", null, "Exporter en Excel")
      ], -1)
    ]))]),
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(stats.value.percent) + "%", 1),
        _createElementVNode("div", {
          class: "h-100p flex align-items-center rounded-100 px-7 bg-pop-green",
          style: _normalizeStyle({'width': stats.value.percent + '%'})
        }, [
          _createElementVNode("h2", null, _toDisplayString(_unref(formatAmount)(stats.value.total_effectue)) + " F", 1),
          _createElementVNode("h2", _hoisted_3, "  / " + _toDisplayString(_unref(formatAmount)(stats.value.total_attendu)) + " F", 1)
        ], 4)
      ])
    ]),
    item: _withCtx(({ item }) => [
      _createElementVNode("div", {
        class: _normalizeClass([{'active': item.statut == 'validated'}, "widget border border-3 shadow-200 rounded-30 gap-5 px-7 py-5"])
      }, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h6", _hoisted_5, _toDisplayString(_unref(formatDateFrench)(item.date_prevision)), 1),
          _createElementVNode("h3", _hoisted_6, _toDisplayString(_unref(formatAmount)(item.montant)) + " F", 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          (item.statut == 'pending')
            ? (_openBlock(), _createElementBlock("h5", _hoisted_8, _toDisplayString(item.countdown), 1))
            : _createCommentVNode("", true),
          (item.statut == 'validated')
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [...(_cache[1] || (_cache[1] = [
                _createElementVNode("span", { class: "tag-state notif stroke" }, "Effectué", -1)
              ]))]))
            : _createCommentVNode("", true),
          (item.statut == 'validated')
            ? (_openBlock(), _createElementBlock("h6", _hoisted_10, _toDisplayString(item.date_operation), 1))
            : _createCommentVNode("", true)
        ])
      ], 2)
    ]),
    _: 1
  }, 8, ["items", "loading"]))
}
}

})